module.exports = __webpack_public_path__ + "img/Harpe-og-dolk_Bilde-av-frimerke-under-Forelskelse-og-begjær.d1bead44.jpg";